declare const __APP_VERSION__: string;

export const APP_VERSION = __APP_VERSION__;
export const APP_VERSION_DISPLAY = `v${APP_VERSION}`;
